import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconNoMeals = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconNoMeals",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m760-315-83-83-117-117v-165q0-34 15-69t37-65 51-47 55-19q18 0 30 14t12 33zm88 258q-12 12-28 12t-29-12l-63-62h32q0 17-11 29t-29 11-28-11-12-29v-48L56-791q-12-12-12-29t12-29 29-12 28 12l735 736q12 12 12 28t-12 28M480-595l-80-80v-165q0-17 12-28t28-12 29 12 11 28zM360-715l-80-80v-45q0-17 12-28t28-12 29 12 11 28zM240-835l-45-45q19 0 32 13t13 32m80 755q-17 0-28-11t-12-29v-326q-51-14-85-56t-35-98v-201l80 80v121h40v-81l80 80v1h1l90 90q-16 23-39 40t-52 24v326q0 17-11 29t-29 11"
  })
}));